import {z} from "zod"
import {PaginationMeta} from "./strapi"

export interface UnifiedListResponse<TItem> {
  data: TItem[]
  meta: {
    pagination: z.infer<typeof PaginationMeta>
  }
  error?: object
}

export function isUnifiedListResponse(
  result: any,
): result is UnifiedListResponse<any> {
  return (
    Array.isArray((result as UnifiedListResponse<any>).data) &&
    (result as UnifiedListResponse<any>).meta?.pagination !== undefined
  )
}
